<template>
  <div id="company-tabs">
    <div style="font-size:16px;margin-bottom:10px;font-weight:bold;">{{ company.name }}&lt;{{ company.id }}&gt;</div>
    <div class="el-tabs el-tabs--card el-tabs--top">
      <div class="el-tabs__header is-top">
        <div class="el-tabs__nav-wrap is-top">
          <div class="el-tabs__nav-scroll">
            <div role="tablist" class="el-tabs__nav is-top" style="transform: translateX(0px);">
              <div v-for="tab in tabs" :key="tab.path" :class="['el-tabs__item', 'is-top', $route.path.indexOf(tab.path) > 0 ? 'is-active' : '']" @click="goPath(tab.path)">{{ tab.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="el-tabs__content">
        <div role="tabpanel" class="el-tab-pane">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      company: {
        id: 0,
        name: ''
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    tabs () {
      if (this.user.role_id < 3) { // 管理人员
        return [
          { path: '/details', title: 'Details' },
          { path: '/bussiness', title: 'Bussiness' },
          { path: '/items-record', title: 'Items Record' },
          { path: '/doc-record', title: 'Doc Record' },
          { path: '/automation', title: 'Automation' },
          { path: '/document', title: 'Document' },
          { path: '/history-record', title: 'History Record' }
        ]
      }
      if (this.user.id === this.company.sales_id || this.user.id === this.company.sales2_id) { // 该客户对应的销售员
        return [
          { path: '/details', title: 'Details' },
          { path: '/bussiness', title: 'Bussiness' },
          { path: '/items-record', title: 'Items Record' },
          { path: '/automation', title: 'Automation' },
          { path: '/document', title: 'Document' },
          { path: '/history-record', title: 'History Record' }
        ]
      }
      // 其他人
      return [
        { path: '/details', title: 'Details' }
      ]
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.company.id = this.$route.params.id
      this.$http.get('/dbapi/company_list', {
        params: {
          id: this.$route.params.id
        }
      }).then(data => {
        if (data.list.length > 0) {
          this.company = data.list[0]
        }
      })
    },
    goPath (path) {
      this.$router.replace(`/customer/company/${this.company.id}${path}`)
    }
  }
}
</script>

<style lang="scss">
#company-tabs {
  font-size: 12px;
  padding-right: 10px;
  .el-tabs__header {
    border-left: 1px solid #404040;
  }
  .el-tabs__item {
    background-color: #bdd1e3;
    border-top: 1px solid #404040;
    border-right: 1px solid #404040;
    height: 24px;
    line-height: 24px;
    &.is-active {
      background-color: #e6ddff;
      border-bottom: 0;
      color: #000;
    }
  }
  .el-rate__icon {
    margin-right: 0;
  }
  .star-good {
    color: #ff9900;
  }
  .star-bad {
    color: #000;
  }
  .hide-name {
    background-color: yellow;
  }
  .hide-bg {
    background-color: yellow;
  }
  .el-tag {
    margin-bottom: 10px;
  }
  .el-tag+.el-tag {
    margin-left: 10px;
  }
  .el-checkbox-group {
    .el-checkbox+.el-checkbox {
      margin-left: 10px;
    }
  }
  .el-button--text {
    padding: 0;
  }
}
</style>